module.exports = __webpack_public_path__ + "img/card.7316a113.svg";